import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    mailParams?: Record<string, string>;
    displayMailButton?: boolean;
    displayPrintButton?: boolean;
};

const ResultTitle = ({
    mailParams = {},
    displayMailButton = true,
    displayPrintButton = true
}: Props) => {
    const { t } = useGranite();

    const printPage = () => window.print();
    const mailPage = () => {
        const link = `Link to the calculator page: ${
            window.location + determineMailQuery()
        }`;

        window.open(`mailto:?subject=Hubo calculator&body=${link}`);
    };
    const determineMailQuery = () => {
        let query = `%3F${Object.keys(mailParams)[0]}=${
            mailParams[Object.keys(mailParams)[0]]
        }`;

        const e = Object.keys(mailParams).slice(1);
        for (let index = 0; index < e.length; index++) {
            query += `%26${e[index]}=${mailParams[e[index]]}`;
        }

        return query;
    };

    return (
        <Row
            id="resultTitle"
            className={cn(
                "tw:border-t-solid tw:border-t tw:border-grey-light tw:mt-8"
            )}
        >
            <Col
                sm={4}
                className={cn("tw:pt-8")}
            >
                <h2 className={cn("tw:inline")}>{t("calculator.result")}</h2>
            </Col>
            <Col
                sm={8}
                className={cn("tw:pt-8")}
            >
                {displayPrintButton && (
                    <Button
                        className={cn("tw:float-right tw:w-max")}
                        color="link"
                        type="button"
                        onClick={() => printPage()}
                    >
                        <i className="la-lg las la-print mr-2"></i>
                        {t("calculator.print")}
                    </Button>
                )}
                {displayMailButton && (
                    <Button
                        className={cn("tw:float-right tw:w-max")}
                        color="link"
                        type="button"
                        onClick={() => mailPage()}
                    >
                        {t("calculator.sendEmail")}
                    </Button>
                )}
            </Col>
            <Col
                sm={{ size: 4 }}
                className={cn("tw:pt-8")}
            >
                <h2 className={cn("tw:inline")}>{t("calculator.result")}</h2>
            </Col>
        </Row>
    );
};

export default ResultTitle;
